'use client';

// Logging lato client.
// STUB: no-op per ora, da collegare alla telemetria reale.

import { useEffect } from 'react';

export default function ClientLogging() {
  useEffect(() => {
    // no-op (hello-world)
  }, []);

  return null;
}
